import { Component, Vue, Prop as prop} from 'nuxt-property-decorator';

@Component
export default class CheckboxFieldComponent extends Vue {

    @prop()
    public title: string;

    @prop({
        default: 'checkbox',
    })
    public type: string;

    @prop()
    public value: string | string[];

    @prop()
    public val: string;

    @prop()
    public name: string;

    get checked(): boolean {

        if (Array.isArray(this.value)) {
            return this.value.includes(this.val);
        } else {
            return this.value === this.val;
        }
    }

    public trigger(event) {
        this.$emit('trigger', this.val);
    }
}
